import { useDocumentsRepository } from '@Hooks/useRepository';
import type { ApiDynamicExportOption } from '@Model';
import { DynamicExportDefinitionRepository } from '@Repositories/Documents';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export interface DynamicExportOptionsInfo {
    exportOptions: ApiDynamicExportOption[];
    refetch: () => void;
    hasExportOptions: boolean;
    currentExportOption: ApiDynamicExportOption | undefined;
    setCurrentExportOption: (exportOption: ApiDynamicExportOption | undefined) => void;
}

/**
 * The exports the current Mandant can run. The backend resolves them across the mandant-specific and
 * the system-wide layer, so an export the Mandant has not configured itself can still be offered.
 */
export function useDynamicExportOptions(category: string, key?: string): DynamicExportOptionsInfo {
    const [currentExportOption, setCurrentExportOption] = useState<ApiDynamicExportOption>();

    const exportDefinitionsRepository = useDocumentsRepository(DynamicExportDefinitionRepository);

    const { data: queryResult, refetch } = useQuery({
        queryFn: () => exportDefinitionsRepository.availableDynamicExports(category, key),
        queryKey: ['dynamicexports', 'categories', category, key],
    });

    const exportOptions = queryResult?.data ?? [];
    const hasExportOptions = exportOptions.length > 0;

    return {
        exportOptions,
        hasExportOptions,
        refetch,
        currentExportOption,
        setCurrentExportOption,
    };
}
